import { type DictionaryPhrases, RestDictionaryService } from "@sitecore-jss/sitecore-jss-react";
import { type RestDictionaryServiceConfig, type RestDictionaryServiceData } from "@sitecore-jss/sitecore-jss/types/i18n/rest-dictionary-service";
import config from "~/temp/config";

// Removes sc_apikey from url
class ClientDictionaryService extends RestDictionaryService {

	constructor(options: Omit<RestDictionaryServiceConfig, "apiKey">) {
		super(options as RestDictionaryServiceConfig);
	}

	async fetchDictionaryData(language: string): Promise<DictionaryPhrases> {
		const endpoint = this.getUrl(language);
		const cachedValue = this.getCacheValue(endpoint);
		if (cachedValue) {
			return cachedValue;
		}

		const request = await fetch(endpoint);
		const response = await request.json() as RestDictionaryServiceData;

		return this.setCacheValue(endpoint, response.phrases);
	}
}

export class DictionaryServiceFactory {
	create(siteName: string) {
		return new ClientDictionaryService({
			apiHost: config.sitecoreApiHost,
			siteName,
		});
	}
}

export const dictionaryServiceFactory = new DictionaryServiceFactory();
